import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';
import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from 'services/scaffoldData/constants';
import { WaterSourceState, WaterSourceActions } from './types';

const initialState: WaterSourceState = [];

export default function (
    state: WaterSourceState = initialState,
    action: WaterSourceActions
): WaterSourceState {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED:
            return get(action, 'response.waterSource', []);
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
